export const PACKAGE_VERSION = "5.5.4";

export function buildSdkHeaderValue(sdkName: string): string {
  return `${sdkName} ${PACKAGE_VERSION}`;
}
